import React, { useContext, useEffect, useState } from "react";
import { Button, ButtonProps } from "@xometry/xometry_loft";

import { PfsFile } from "../../schema/generated/schema";

import fileUtils from "../../utils/fileUtils";
import { trackClick, TrackingEvent } from "../../utils/trackingUtils";
import ModelViewerContext from "../proposals/contexts/modelViewerContext";
import { useConfig } from "../proposals/contexts/configContext";

interface Props extends ButtonProps {
  file: PfsFile;
}

const HoopsButton: React.FC<Props> = props => {
  const { file, children, ...rest } = props;

  const { openModelViewer } = useContext(ModelViewerContext);
  const [streamcacheError, setStreamcacheError] = useState(false);
  const [streamcacheReady, setStreamcacheReady] = useState(false);
  const shouldHaveStreamcache = fileUtils.shouldHaveStreamcacheFile(file);
  const { origins } = useConfig();

  useEffect(() => {
    async function tryGetStreamcacheUrl() {
      const url = await fileUtils.getFileStreamcacheUrl(
        origins.partFilesService,
        file.id
      );

      if (url) {
        setStreamcacheReady(true);
      }
    }

    if (shouldHaveStreamcache) {
      fileUtils.callWithRetry(tryGetStreamcacheUrl).catch(() => {
        setStreamcacheError(true);
      });
    }
  }, [file]);

  if (!shouldHaveStreamcache || streamcacheError) {
    return null;
  }

  const handleClick: React.MouseEventHandler = event => {
    event.stopPropagation();
    trackClick(TrackingEvent.VIEW_3D_BUTTON_CLICKED, { fileId: file.id });

    if (openModelViewer) {
      openModelViewer(file);
    }
  };

  return (
    <>
      {streamcacheReady && (
        <Button {...rest} onClick={handleClick}>
          {children}
        </Button>
      )}
    </>
  );
};

export default HoopsButton;
